(function () {
  function initReveal() {
    var items = document.querySelectorAll('.lv-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('lv-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lv-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll('[data-lv-marquee-speed]').forEach(function (track) {
      var speed = parseFloat(track.getAttribute('data-lv-marquee-speed')) || 32;
      track.style.animationDuration = speed + 's';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMarquee();
  });
})();
